import TableHead from '@mui/material/TableHead';
import { TableCellBody, TableCellHead, TableRow } from './common/Table';
import TableBody from '@mui/material/TableBody';
import TableSortLabel from '@mui/material/TableSortLabel';
import { BoldTypography } from './common/TextLabel';
import Moment from 'react-moment';
import Table from '@mui/material/Table';
import { decode } from 'he';
import { ReactComponent as CopyContentIcon } from '../icons/copy-content.svg';
import { SvgIcon } from '@mui/material';
import copyToClipboard from './utils/copyToClipboard';
import ProducerHeading from './ProducerHeading';
import { VideoLibItem } from './types/videos';

type VidLibProps = {
  videos: VideoLibItem[],
  onSetVideoPreview: (y: number) => void,
  setOrderDirection: (x: 'desc' | 'asc') => void,
  setOrderBy: (x: string) => void,
  orderBy: string,
  orderDirection: 'desc' | 'asc',
}

export const VideoLibraryTable = ({
  videos,
  onSetVideoPreview,
  setOrderDirection,
  setOrderBy,
  orderDirection,
  orderBy
}: VidLibProps) => {

  return (
    <Table size="small">
      <TableHead>
        <TableRow>
          <TableCellHead>VIDEO</TableCellHead>
          <TableCellHead>
            <TableSortLabel
              active={orderBy === 'title'}
              direction={orderDirection}
              onClick={() => {
                setOrderDirection(orderDirection === 'desc' ? 'asc' : 'desc');
                setOrderBy('title');
              }}
            >TITLE
            </TableSortLabel>
          </TableCellHead>
          <TableCellHead>
            <TableSortLabel
              active={orderBy === 'created_at'}
              direction={orderDirection}
              onClick={() => {
                setOrderDirection(orderDirection === 'desc' ? 'asc' : 'desc');
                setOrderBy('created_at');
              }}
            >Created at</TableSortLabel>
            </TableCellHead>
          <TableCellHead>SUMMARY</TableCellHead>
          <TableCellHead>IAB CATEGORY</TableCellHead>
          <TableCellHead>DURATION</TableCellHead>
          <TableCellHead>RIGHTSHOLDER</TableCellHead>
          <TableCellHead></TableCellHead>
        </TableRow>
      </TableHead>
      <TableBody>
        {videos.length === 0 && (
          <TableRow>
            <TableCellBody colSpan={7} width={'100%'}>
              <div style={{ textAlign: 'center', padding: 20 }}>There are no videos yet</div>
            </TableCellBody>
          </TableRow>
        )}
        {videos &&
          videos.map((row, index) => (
            <TableRow
              sx={{
                height: '60px',
              }}
              key={row.media_id}
            >
              <TableCellBody
                sx={{ width: row.format === 'vertical' ? '104px' : '160px', position: 'relative' }}
                onClick={() => {
                  onSetVideoPreview(index);
                }}
              >
                {row.format === 'vertical' && (
                  <><div
                    style={{
                      backgroundImage: `url(${row.thumbnail || '/bg-grey.png'})`,
                      backgroundRepeat: 'no-repeat',
                      backgroundSize: 'cover',
                      height: '128px',
                      borderRadius: '5%',
                    }}
                  ></div>
                    { row.parent_media_id && <img src="/logo/pixels.png" style={{
                    width: '24px',
                    borderRadius: '4px',
                    position: 'absolute',
                    top: '2px',
                    right: '10px',
                  }} alt=""/> }
                    </>
                )}
                {row.format === 'horizontal' && (
                  <div
                    style={{
                      backgroundImage: `url(${row.thumbnail || '/bg-grey.png'})`,
                      backgroundRepeat: 'no-repeat',
                      backgroundSize: 'cover',
                      height: '72px',
                      borderRadius: '5%',
                    }}
                  ></div>
                )}
              </TableCellBody>
              <TableCellBody sx={{ minWidth: '287px' }}>
                {decode(row.title)}
                <div title={row.media_id} style={{ cursor: 'pointer', marginTop: '10px' }}>
                  <SvgIcon onClick={copyToClipboard(row.media_id)}>
                    <CopyContentIcon />
                  </SvgIcon>
                </div>
              </TableCellBody>
              <TableCellBody>
                <BoldTypography style={{ whiteSpace: 'nowrap' }}>
                  <Moment format="D MMM YYYY">{row.publish_date}</Moment>
                </BoldTypography>
              </TableCellBody>
              <TableCellBody>
                <BoldTypography>{row.summary}</BoldTypography>
              </TableCellBody>
              <TableCellBody>
                <BoldTypography>
                  {row.iab_topics.map(({ text, score }) => (
                    <span key={text} title={score} style={{ display: 'block' }}>
                      {text} ({(score * 100).toFixed(0)}%)
                    </span>
                  ))}
                </BoldTypography>
              </TableCellBody>
              <TableCellBody>{row.duration}</TableCellBody>
              <TableCellBody sx={{ minWidth: '150px' }}>
                <ProducerHeading row={row} />
              </TableCellBody>
              <TableCellBody sx={{ minWidth: '150px' }}>
              </TableCellBody>
            </TableRow>
          ))}
      </TableBody>
    </Table>
  );
};
